/* eslint-disable camelcase */

import { makeAutoObservable, set } from 'mobx'

class Paginator {
  completeSort = {}
  count = 0
  current = 0
  direction = 'asc'
  directionDefault = 'asc'
  end = 0
  finder = 'all'
  limit = null
  nextPage = false
  page = 0
  pageCount = 0
  perPage = 0
  prevPage = false
  scope = null
  sort = ''
  sortDefault = ''
  start = 0

  constructor (data) {
    makeAutoObservable(this)
    set(this, data)
  }
}

export default Paginator
